/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApprovalReportDates } from '../../models/approval-report-dates';

export interface GetOpenApprovalReportDates$Params {
  workCenterId: number;
}

export function getOpenApprovalReportDates(http: HttpClient, rootUrl: string, params: GetOpenApprovalReportDates$Params, context?: HttpContext): Observable<StrictHttpResponse<ApprovalReportDates>> {
  const rb = new RequestBuilder(rootUrl, getOpenApprovalReportDates.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApprovalReportDates>;
    })
  );
}

getOpenApprovalReportDates.PATH = '/api/v1/workCenterGroups/{workCenterId}/approvals/approvalReportDates';
